"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _MultiSelect = _interopRequireDefault(require("./MultiSelect"));
var _ButtonList = _interopRequireDefault(require("./ButtonList"));
var _YesNoButtons = _interopRequireDefault(require("./YesNoButtons"));
var _styles = require("./styles");
var _constants = require("../../lib/constants");
const {
  MULTI_SELECT,
  BUTTON_LIST,
  YES_NO_BUTTONS
} = _constants.uiControls;
const Footer = _ref => {
  let {
    answer,
    ariaDescribedby,
    id,
    onAnswer,
    options,
    uiControl
  } = _ref;
  const InputComponent = {
    [MULTI_SELECT]: _MultiSelect.default,
    [BUTTON_LIST]: _ButtonList.default,
    [YES_NO_BUTTONS]: _YesNoButtons.default
  }[uiControl];
  if (!InputComponent) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement(_styles.FooterContainer, null, /*#__PURE__*/_react.default.createElement(InputComponent, {
    answer: answer,
    ariaDescribedby: ariaDescribedby,
    id: id,
    onAnswer: onAnswer,
    options: options
  }));
};
var _default = exports.default = Footer;
Footer.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Footer"
};